import { getAxiosConfig } from "@/services/axiosConfig";
import {
  IBestSellerDataGeneric,
  IBestSellers,
  IBrandsGeneric,
} from "global-types/global.types";
import { useQuery } from "react-query";

export default function useTopDiscount(slug: string[]) {
  const { data: topDiscount, isLoading: isLoadingTopDiscount } = useQuery(
    ["TOP_DISCOUNT", slug],
    async () => {
      if (!slug) return null;

      const res = await getAxiosConfig().get<
        IBestSellers<IBestSellerDataGeneric<IBrandsGeneric>[]>
      >(
        `/category/product?category_id=${slug}&take=5&is_category_product_of_day=1`
      );

      return res.data;
    }
  );

  return {
    topDiscount,
    isLoadingTopDiscount,
  };
}
